import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useUsersApi() {
const { config } = useContext(GlobalContext);
const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000"

// ✅ Helper to include token in headers
function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    "X-token": token || "",
  };
}

// ✅ Get all vendor users
// ✅ Get all vendor users with optional search
async function getAllVendorUsers({ limit = 5, offset = 0, search = "" }) {
  const response = await fetch(`${BASE_URL}/get_all_vendor_user`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ limit, offset, search: search.trim() || undefined }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch users");
  }

  return data; // { data: [...], limit, offset, total, success }
}

// ✅ Encrypt password
async function getEncryptedPassword(password) {
  const response = await fetch(`${BASE_URL}/encrypt_password`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ password }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to encrypt password");
  return data.data; // encrypted password string
}

// ✅ Register vendor user
async function registerVendorUser(userData) {
  const encryptedPassword = await getEncryptedPassword(userData.password);
  const payload = { ...userData, password: encryptedPassword };

  const response = await fetch(`${BASE_URL}/register_vendor_user`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to register user");
  return data; // { success: true, message, data: {...} }
}

// ✅ Get all recipients for a user
async function getAllRecipient(userId) {
  const response = await fetch(`${BASE_URL}/get_all_recipient`, {
    method: "GET",
    headers: getAuthHeaders()
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch recipients");
  return data; // { success, data: [...], message }
}

// ✅ Delete vendor user
async function deleteVendorUser(userId) {
  const response = await fetch(`${BASE_URL}/delete_vendor_user/${userId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to delete user");
  return data; // { success, message }
}

// ✅ Get vendor user by ID
async function getVendorUserById(userId) {
  const response = await fetch(`${BASE_URL}/get_vendor_user/${userId}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch user");
  return data.data; // return full user object including decrypted password
}

// ✅ Update vendor user
async function updateVendorUser(userId, updateData) {
  let payload = { ...updateData };
  if (updateData.password && updateData.password.trim() !== "") {
    const encryptedPassword = await getEncryptedPassword(updateData.password);
    payload.password = encryptedPassword;
  } else {
    delete payload.password;
  }

  const response = await fetch(`${BASE_URL}/update_vendor_user/${userId}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to update user");
  return data; // { success, message }
}

 // ✅ RETURN ALL FUNCTIONS
  return {
    getAllVendorUsers,
    registerVendorUser,
    getAllRecipient,
    deleteVendorUser,
    getVendorUserById,
    updateVendorUser
  };

}